import { useMarketContext } from '../contexts/MarketContext'

export default function useMarketId() {
  const { market } = useMarketContext()
  const { selectedMarket } = market
  return selectedMarket.id
}
